import { useContent } from '../context/ContentContext';

/**
 * Only rendered in dev (npm run dev). Floating bar with Save button to write content-config.json.
 */
export default function EditModeBar() {
  const { save, saveStatus, isEditMode } = useContent();

  if (!isEditMode) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 bg-[#1a1a1a] text-white px-4 py-2 rounded-lg shadow-lg border border-[#9a83ad]"
      style={{ fontFamily: 'system-ui, sans-serif' }}
    >
      <span className="text-xs uppercase tracking-wider text-white/80">Edit mode</span>
      <span className="text-xs text-white/60 hidden sm:inline">E to toggle · Ctrl+S to save</span>
      <button
        type="button"
        onClick={save}
        disabled={saveStatus === 'saving'}
        className="px-4 py-2 bg-[#9a83ad] hover:bg-[#8a73a0] disabled:opacity-60 text-white font-semibold rounded text-sm uppercase tracking-wider transition-colors"
      >
        {saveStatus === 'saving' ? 'Saving…' : saveStatus === 'saved' ? 'Saved' : 'Save to config'}
      </button>
      {saveStatus === 'error' && (
        <span className="text-red-400 text-xs">Save failed. Check console.</span>
      )}
    </div>
  );
}
